<script>
    import {push, pop, replace} from 'svelte-spa-router'
	import { onMount } from 'svelte';
	import { elasticOut } from 'svelte/easing';
	import Header from './Header.svelte';

    // The params prop contains values matched from the URL
    export let params = {}

    let selected;
    let selected_id;
	let selected_set = [];
	let selected_rare_set = [];
	let selected_set_tmp = [];
	let last_symbol_id = -1;
	let tapped = 0;
	let tapped_max = 16;
	let tapped_i = -1;
	let last_tapped_i = -1;
	let game_size = 16;
	let found_rare = 0;
	let rare_symbol = '';
	let collected_n = 0;
	let collected_str = '';
	let collected_rare_str = '';
	//$:console.log(selected)

	let mebotStaff = []
	for (let i = 0; i < game_size; i++) {
	  mebotStaff.push({
		id: i,
		name: "",
		watts: "56",
		watt_level: "4",
		img: "/img/mebots-watts.png",
		s: 0,
		text: '',
		rarity: 0
    	//text: '𒈙',
	  });
	}

	function symbol_jump_out(node, { duration }) {
		return {
			duration,
			css: t => {
				const eased = elasticOut(t);

				return `
				transform: scale(${eased});`
			}
		};
	}

	function egg_jump_out(node, { duration }) {
		return {
			duration,
			css: t => {
				const eased = elasticOut(t);

				return `
				transform: scale(${eased}) ;
					color: hsl(
						185,
						${Math.min(100, 1000 * t)}%,
						75%
					);`
			}
		};
	}

	let cardBackShowing = false;

	function arrayRemove(arr, value) {
		return arr.filter(function(ele) {
			return ele != value;
		});
	}

	const toggleBackFront = async (e) => {
		// if same card clicked twice to toggle front and back
		if (selected === Number(e.target.dataset.cardId)) {
//			selected = null;
//			cardBackShowing = !cardBackShowing;
		} else {

			selected = Number(e.target.dataset.cardId)

			//check if this tile is already matched, if so don't do anything
			if (selected_set.includes(selected)) {
				return;
			}

			cardBackShowing = !cardBackShowing;
			last_tapped_i = tapped_i;
//			if (selected_set.length < 4) {
				//find out the value for the card
				selected_id = selected + 1;
				const res = await fetch('https://api.forever.today/?method=get_match2_value', {
					method: 'POST',
					body: JSON.stringify({
						dash_token,
                		mebot_id,
						selected_id,
						game_size
            		})
				});

	        	const json = await res.json()
				mebotStaff[selected].img = json.data.mebot_img_url;
				tapped_i = selected;
				//mebotStaff[selected].s = 1;
				if (typeof json.data.mebot_symbol !== 'undefined') {
					mebotStaff[selected].text = json.data.mebot_symbol;
					mebotStaff[selected].rarity = json.data.rarity;
				}
				//last_symbol_id = json.data.mebot_symbol;

				if (selected_set.length >= 3) {
				//	getDrawSet()
				}
//			}

			if (last_symbol_id == json.data.mebot_symbol) {
				selected_set = [...selected_set, selected];
				if (json.data.rarity == 1) {
					tapped_max = tapped_max + 4;
				}
				last_symbol_id = -1;

				if (is_pulse == false) {
					is_pulse = true
					setTimeout(function(){
						is_pulse = false;
					}, 1200);
				}

			} else {
				if (selected_set.indexOf(selected) === -1) {
					//selected_set = [selected];
					if (last_tapped_i >= 0) {
						if (mebotStaff[last_tapped_i].s == 0) {
							selected_set = arrayRemove(selected_set, last_tapped_i);
						}
					}
					selected_set = [...selected_set, selected];
				}
				tapped = tapped + 1;
			}
			last_symbol_id = json.data.mebot_symbol;

			getDrawSet()
		}
	}

	function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    let dash_token = params.t
    let mebot_id = params.id

	if (dash_token != '1') {
		if (getCookie("m_dash_token") != '') {
			dash_token = getCookie("m_dash_token")
		}
	}

    let result = null
    let mebot_img_url = null;
    let watt_score = '';
    let watt_level = '';
    let mebot_msg = '';
    let steps = '';
    let explorer = '';
    let social = '';
    let hrv = '';
    let sleep = '';
    let m_id = '';
	let frame;
	let confetti_animation = false;

	let is_pulse = false;

	let characters = ['🥳', '🎉', '✨'];
	let confetti = new Array(50).fill().map((_, i) => {
		return {
			character: characters[i % characters.length],
			x: Math.random() * 100,
			y: -20 - Math.random() * 100,
			r: 0.1 + Math.random() * 1.2
		};
	}).sort((a, b) => a.r - b.r);
	
	async function setDrawSet() {
		const res = await fetch('https://api.forever.today/?method=set_match2_set', {
			method: 'POST',
			body: JSON.stringify({
				dash_token,
                mebot_id,
				game_size
            })
		})

        const json = await res.json()
    }

	async function getDrawSet() {
		const res = await fetch('https://api.forever.today/?method=get_match2_set', {
			method: 'POST',
			body: JSON.stringify({
				dash_token,
                mebot_id,
				game_size
            })
		})

        const json = await res.json()

		if (tapped_i >= 0) {
			selected_set_tmp = [tapped_i];
		} else {
			selected_set_tmp = [];
		}
		tapped = json.data.tapped_n;
		for (let i = 0; i < game_size; i++) {
	  		mebotStaff[i].img = json.data.tiles[i+1].img
			mebotStaff[i].s = json.data.tiles[i+1].s
			mebotStaff[i].text = json.data.tiles[i+1].mebot_symbol
			mebotStaff[i].rarity = json.data.tiles[i+1].rarity
			//if (selected_set.indexOf(i) === -1) {
				if (json.data.tiles[i+1].s == 1) {
					//selected_set_tmp = [...selected_set_tmp, i];
					selected_set_tmp = [...selected_set_tmp, i];
				}
			//}
			if (mebotStaff[i].rarity == 1 && mebotStaff[i].s == 1) {
				found_rare = 1;
				//if (!selected_rare_set.includes(mebotStaff[i].text)) {
				//	found_rare++;
				//	selected_rare_set[mebotStaff[i].text] = 1;
				//}
				rare_symbol = json.data.tiles[i+1].mebot_symbol;
			}
		}
		//to avoid flickering
		selected_set = selected_set_tmp;

		//also if uncovered each tile at least once and no matches, end now
		if ((tapped >= tapped_max && selected_set.length <= game_size-2) || selected_set.length >= game_size) {
			tapped_i = -1;
			last_tapped_i = tapped_i;
			if (selected_set.length >= game_size || found_rare > 0) {
				confetti_animation = true;
				confetti_loop();
			}
			collected_n = Math.floor(selected_set.length / 2);
			collected_str = '⚱️ ';
			if (found_rare > 0) {
				collected_n = collected_n - found_rare;
				if (collected_n <= 0) {
					collected_rare_str = '1 '
				} else {
					collected_rare_str = ' + 1'
				}
			}
            if (collected_n == 1) {
				collected_str = '⚱️ 1 '
			} else {
				if (found_rare > 0) {
					if (collected_n > 0) {
						collected_str = '⚱️ ' + collected_n + ' ';
					}
				} else {
					collected_str = '⚱️ ' + collected_n + '';
                }
			}
			for (let i = 0; i < game_size; i++) {
				if (selected_set.indexOf(i) === -1) {
					selected_set = [...selected_set, i];
				}
			}
		}
    }

	function confetti_loop() {
		if (confetti_animation) {
			frame = requestAnimationFrame(confetti_loop);
		}

		confetti = confetti.map(emoji => {
			emoji.y += 0.7 * emoji.r;
			if (emoji.y > 120) emoji.y = -20;
			return emoji;
		});
	}

	async function restartGame() {

		if (tapped >= tapped_max || selected_set.length >= game_size) {
			confetti_animation = false;
			let new_game = 1;
			tapped_i = -1;
			tapped = 0;
			selected = '';
    		selected_id = '';
			selected_set = [];
			selected_rare_set = [];
			last_symbol_id = -1;
			found_rare = 0;
			rare_symbol = '';
			collected_n = 0;
			collected_str = '';
			collected_rare_str = '';
			tapped_max = 16;
			const res = await fetch('https://api.forever.today/?method=set_match2_set', {
				method: 'POST',
				body: JSON.stringify({
					dash_token,
                	mebot_id,
					new_game,
					game_size
            	})
			})

        	const json = await res.json()
			getDrawSet();
		}
    }

    function goTop() {
      document.body.scrollIntoView();
    }

    setDrawSet()
    getDrawSet()
    goTop()

</script>

<!--<button  on:click={() => pop()} style="border-radius: 5px; border: 1px solid #fff; background-color: black; position:absolute; top: 25px; left: 20px; font-size: 10px; color: rgba(255, 255, 255, 1);
    box-shadow: 0 5px 15px rgba(145, 145, 145, .8);"> Mebots <img width="10px" src="infinity-white.png" alt="FOREVER"> </button>
-->

{#if confetti_animation}
	{#each confetti as c}
		<div class="congratulations" style="z-index: 100; left: {c.x}%; top: {c.y}%; transform: scale({c.r})">{c.character}</div>
	{/each}
{/if}

<Header
	header_mebot_id = { mebot_id }
	header_dash_token = { dash_token }
/>
<br><br>
<center>
    <div class="row">
        {#each mebotStaff as {name, watt_level, watts, img, text, s, rarity}, i}
            <div class="flip-box" >
				
                <div class="flip-box-inner" class:show-back={ selected_set.includes(i) }>
                    <div class="flip-box-front card">
                        <div class="vertical-center" on:click={toggleBackFront}>
							<div class="message question" data-card-id={i}>𒊹</div>
                        </div>
                    </div>

                    <div class="flip-box-back container " >

                        {#if text != '' && text != 'egg'}
						<div class="bg_img message mebot_symbol text-electric" class:show-selected-linked={ s == 1 } class:show-unselected={ s == 0 && rarity != 1 } class:show-unselected-rare={ s == 0 && rarity == 1 } class:show-tapped={ (tapped_i == i || last_tapped_i == i) && s == 0} class:show-rare={ rarity == 1 && (tapped_i == i || last_tapped_i == i || s == 1) }>
							{#if s == 1}
                            <div in:symbol_jump_out="{{duration: 2200}}">
								{@html text}
							</div>
							{:else}
								{@html text}
							{/if}
						<!--<img src="/img/mebots-watts.png" alt="" class:show-selected={ s == 1 } class:show-unselected={ s == 0 }>-->
						</div>
						{:else}
							{#if text == 'egg' && s == 1}
								<img in:egg_jump_out="{{duration: 2200}}" src={img} alt={name} class:show-selected-linked={ s == 1 } class:show-unselected={ s == 0 }>
							{:else}
								<img src={img} alt={name} class:show-selected={ s == 1 } class:show-unselected={ s == 0 }>
							{/if}
                        {/if}

                    </div>
                </div>

            </div>
        {/each}
    </div>

	<div class="small_row">
		<table width=300px>
		<tr><td align=left valign=middle height=30px>
		<span class="text-electric info" class:pulsing={ is_pulse } >
		<span class="text-electric-white" style="display: flex; align-items:center;" >
			&nbsp;
		{#if collected_str == '' || typeof collected_str === 'object' }
		🔄 { isNaN(tapped_max-tapped) ? game_size : (tapped_max-tapped) }
		{:else}
			{ collected_str } <span class="text-electric-gold"> { collected_rare_str } </span>
		{/if}
		</span>
		</span>
		</td></tr></table>
	</div>

	{#if ((tapped >= tapped_max && selected_set.length <= game_size-2) || selected_set.length >= game_size) }
		<span on:click={restartGame} class="vitals_bold text-electric" style="font-size: 50px; -webkit-tap-highlight-color: transparent; -webkit-touch-callout: none; user-select: none; text-decoration: none;">&#8634;</span>
	{/if}
</center>

<style>
	:global(body, html){
		background-color: #000;
		height: 800px;
		overflow-x: hidden;
	}

	.congratulations {
		position: absolute;
		font-size: 5vw;
		user-select: none;
	}

    .text-electric {
		  text-shadow: 0 0 32px rgba(192, 253, 255, 0.9), 0 0 32px rgba(65, 255, 249, 0.98);
		  font-family: arial;
          color: hsl(185, 97%, 75%);
	}
	.text-electric-gold {
		  text-shadow: 0 0 60px rgba(255, 250, 192, 0.9), 0 0 40px rgba(255, 239, 65, 0.98);
		  font-family: arial;
		  color: hsl(49, 100%, 50%);
	}

	.vitals_bold {
		font-size: 34px;
	}

	.mebot_symbol {
		font-size: 24px;
	}

	.question {
		color: white;
		font-size: 18px;
		text-shadow: 0 0 40px rgba(195, 195, 195, 0.9), 0 0 32px rgba(255, 255, 255, 0.98);
		font-family: arial;
	}
	
	.row {
		display: flex;
		flex-wrap: wrap;
        width: 350px;
		justify-content: center;
		margin-bottom: 10px;
	}
	.small_row {
		display: flex;
		flex-wrap: wrap;
        width: 350px;
		margin-bottom: 10px;
		margin-left: 32px;
		margin-right: 36px;
	}
	.info {
		font-size: 18px;
		justify-content: right;
	}

	/* The flip box container - set the width and height to whatever you want. We have added the border property to demonstrate that the flip itself goes out of the box on hover (remove perspective if you don't want the 3D effect */
	.flip-box {
		background-color: transparent;
		width: 70px;
		height: 70px;
		margin: 0 6px 12px;
		border: 0px solid #f1f1f1;
		perspective: 1000px; /* Remove this if you don't want the 3D effect */
	}

	/* This container is needed to position the front and back side */
	.flip-box-inner {
		position: relative;
		width: 100%;
		height: 100%;
		text-align: center;
		transition: transform 0.4s;
		transform-style: preserve-3d;
	}


	/* Style the back side */
	.flip-box-back {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		color: white;
		width: 60px;
		height: 60px;
		transform: rotateY(180deg) translateX(6px);
	}

		/* Some left and right padding inside the container */
	.container {
		padding: 0px 6px;
	}

	/* Do an horizontal flip when you move the mouse over the flip box container */
/* 	.flip-box:hover .flip-box-inner {
		transform: rotateY(180deg);
	}*/
	
	.show-back {
		transform: rotateY(180deg);
	}

	.show-selected {
		background-color: rgb(26, 26, 26);
		border-radius: 10px;
		box-shadow: 0 0 10px rgba(90, 91, 91, 0.4), 0 0 20px rgba(130, 132, 132, 0.819);
	}

	.show-selected-linked
	{
		background-color: rgb(26, 26, 26);
		border-radius: 10px;
		box-shadow: 0 0 10px rgba(192, 253, 255, 0.4), 0 0 20px rgba(65, 255, 249, 0.8);
	}
	.show-unselected {
		text-shadow: 0 0 40px rgba(192, 253, 255, 0.9), 0 0 32px rgba(65, 255, 249, 0.98);
		font-family: arial;
		color: hsl(185, 97%, 75%);
		opacity: 40%;
	}
	.show-unselected-rare {
		text-shadow: 0 0 40px rgba(192, 253, 255, 0.9), 0 0 32px rgba(65, 255, 249, 0.98);
		font-family: arial;
		color: hsl(49, 100%, 50%);
		opacity: 40%;
	}
	.show-tapped {
		text-shadow: 0 0 40px rgba(192, 253, 255, 0.9), 0 0 32px rgba(240, 240, 240, 0.98);
		font-family: arial;
        color: hsl(0, 0%, 100%);
		opacity: 90%;
	}
	.show-rare {
		text-shadow: 0 0 40px rgba(192, 253, 255, 0.9), 0 0 32px rgba(240, 240, 240, 0.98);
		font-family: arial;
        color: hsl(49, 100%, 50%);
		opacity: 90%;
	}

	.bg_img {
 		background-color: #131313;
		background-color: rgb(26, 26, 26);
		border-radius: 10px;
		box-shadow: 0 0 10px rgba(90, 91, 91, 0.4), 0 0 20px rgba(130, 132, 132, 0.819);
		width: 60px;
		height: 60px;
	}

	/* Position the front and back side */
	.flip-box-front, .flip-box-back {
		position: absolute;
		width: 100%;
		height: 100%;
		-webkit-backface-visibility: hidden; /* Safari */
		backface-visibility: hidden;
	}

	/* Style the front side */
	.flip-box-front {
/*		background-color: rgba(247, 233, 26, 0.932);*/
      background-color: #2992ad;
	}

    .vertical-center {
        margin: 0;
        position: absolute;
        top: 46%;
        left: 52%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }

    .message {
        margin: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }

	img {
		max-height: 90%;
	}	

	/* Add some shadows to create a card effect */
	.card {
        border-radius: 10px;
        color: rgb(216, 79, 0);
		box-shadow: 0 4px 8px 0 rgba(189, 140, 104, 0.2);
	}

	.pulsing {
		font-weight: bold;
		transform: scale(1.5);
		animation: zombie-fight 0.5s infinite;
	}

	@keyframes zombie-fight {
	0% {
		transform: scale(1);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}

	10% {
		transform: scale(1.3);
		text-shadow: 0 0 32px rgba(192, 255, 220, 0.9),
			0 0 32px rgba(65, 255, 170, 0.98);
		color: hsla(167, 97%, 75%, 0.36);
	}

	100% {
		transform: scale(1);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	}
</style>
